import * as React from "react"
import { connect } from "react-redux"

import { FieldItems, ReadOnly } from "@tenforce/toolbox-field-react"

import { DispatchProps, mapDispatchToProps } from "../actions"

import CardViewInlineAttachment from "../../inlineattachments/components/CardViewInlineAttachment"
import ContextMenu from "../../common/contextmenu/components/ContextMenu"
import ContextMenuModalContent from "./ContextMenuModalContent"
import { Labels } from "../../../util/Translations"
import { ICardViewItem } from "../index"

interface OwnProps {
    item: ICardViewItem
}

type Props = OwnProps & DispatchProps

export class ItemCard extends React.Component<Props> {
    render(): JSX.Element {
        const { item } = this.props
        const {
            number,
            listName,
            title,
            status,
            id,
            contextMenu,
            areAttachmentsEnabled,
        } = item

        const url = `${window.location.href}/${id}`
        const label = number
            ? `${number} · ${listName} · ${status}`
            : `${listName} · ${status}`

        const anchorClasses = `NewUI-card bg-cloud tw-w-full has-hidden-actions ${
            contextMenu?.isShown ? "is-focused" : ""
        }`

        const { Attachments } = Labels
        return (
            <article
                className="tw-w-full md:tw-w-1/2 lg:tw-w-1/4 tw-p-2"
                data-ft-card="item"
                data-ft-card-title={title}
                data-ft-id={id}
            >
                <a
                    href={url}
                    className={anchorClasses}
                    data-ft-component="anchor"
                >
                    <div className="NewUI-card__block">
                        <div className="tw-flex tw-items-center">
                            <FieldItems
                                extraClasses="tw-flex-1 tw-min-w-0"
                                label={label.toLocaleUpperCase()}
                                title={label}
                            >
                                <ReadOnly
                                    extraClasses="h4"
                                    data-ft-component="title"
                                    value={title.toLocaleUpperCase()}
                                />
                            </FieldItems>

                            <ContextMenu
                                isModalShown={
                                    !!contextMenu && contextMenu.isShown
                                }
                                hideModal={this.hideContextMenu}
                                isActionHidden={true}
                                modalId="itemCardContextMenuModal"
                                showModal={this.showContextMenu}
                            >
                                <ContextMenuModalContent item={item} />
                            </ContextMenu>
                        </div>

                        {areAttachmentsEnabled && (
                            <FieldItems
                                label={Attachments.toLocaleUpperCase()}
                                data-ft-component="attachments"
                            >
                                <CardViewInlineAttachment item={item} />
                            </FieldItems>
                        )}
                    </div>
                </a>
            </article>
        )
    }

    showContextMenu = (event: React.MouseEvent): void => {
        event.preventDefault()
        const {
            item: { id },
            showContextMenu,
        } = this.props
        showContextMenu(id)
    }

    hideContextMenu = (): void => {
        const {
            item: { id },
            hideContextMenu,
        } = this.props
        hideContextMenu(id)
    }
}

export default connect(null, mapDispatchToProps)(ItemCard)
